import React, { useCallback } from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import usePropertiesAdmin from 'hooks/usePropertiesAdmin';

import CogIcon from 'ui-kit/icons/cog-icon/cog-icon';
import DataGrid from 'ui-kit/data-grid/data-grid';

import './style.css';

const PropertyList = ({ onArchiveProperty, onCloseBidding, onOpenBidding, onUndoArchiveProperty, onViewProperty }) => {
    const { properties = [] } = usePropertiesAdmin();

    const getColumns = useCallback(() => {
        return [
            {
                label: 'Status',
                field: 'isBiddingOpen',
                exportable: true,
                cellRenderer: (id, { isArchived, isBiddingOpen }) => {
                    return (
                        <div key={`property-status-cell-${id}`} className="property-status-row-cell">
                            {isBiddingOpen && !isArchived && <FontAwesomeIcon icon="book-open" />}
                            {!isBiddingOpen && !isArchived && <FontAwesomeIcon icon="book" />}
                            {isArchived && <FontAwesomeIcon icon="archive" />}
                        </div>
                    );
                }
            },
            {
                label: 'Address',
                field: 'address',
                exportable: true
            },
            {
                label: 'Parcel Number',
                field: 'parcelNumber',
                exportable: true,
                key: true
            },
            {
                label: 'Archived',
                field: 'archivedOn',
                exportable: true
            },
            {
                label: 'Bids',
                field: 'bidCount',
                exportable: true
            },
            {
                label: 'Date Added',
                field: 'dateAdded',
                exportable: true
            },
            {
                label: 'Actions',
                field: 'actions',
                cellRenderer: ({ id, isArchived, isBiddingOpen }) => {
                    return (
                        <Dropdown>
                            <Dropdown.Toggle>
                                <CogIcon style={{ height: '1.5rem', width: '1.5rem' }} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => onViewProperty({ id })}>View</Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item
                                    disabled={isArchived}
                                    onClick={() => onArchiveProperty && onArchiveProperty({ id })}
                                >
                                    Archive
                                </Dropdown.Item>
                                <Dropdown.Item
                                    disabled={!isArchived}
                                    onClick={() => onUndoArchiveProperty && onUndoArchiveProperty({ id })}
                                >
                                    Undo Archive
                                </Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item disabled={!isBiddingOpen} onClick={() => onCloseBidding({ id })}>
                                    Close Bidding
                                </Dropdown.Item>
                                <Dropdown.Item disabled={isBiddingOpen} onClick={() => onOpenBidding({ id })}>
                                    Open Bidding
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    );
                }
            }
        ];
    }, [properties]);
    const columns = getColumns();

    return <DataGrid id="property-list" columns={columns} data={properties} filters={[columns[1], columns[2]]} />;
};

export default PropertyList;
